import * as React from "react";
import type { SVGProps } from "react";
const SvgFavoriteFilled = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            d="M10.532 4.9 12 6l1.468-1.1A4.708 4.708 0 0 1 21 8.664v.463c0 1.859-.633 3.663-1.794 5.114a19.7 19.7 0 0 1-5.234 4.575L12 20l-1.972-1.183a19.7 19.7 0 0 1-5.234-4.575A8.2 8.2 0 0 1 3 9.128v-.463A4.708 4.708 0 0 1 10.532 4.9"
        />
    </svg>
);
export default SvgFavoriteFilled;
